import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  GlobalActions,
  CompanySelection,
  VibeButton,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';

function PartnerCompanies({
  allowChanges = false,
  companies: propCompanies = [],
  setPanel,
  onUpdate = () => {},
}) {
  const [companies, setCompanies] = useState(propCompanies);

  /**
   * When the companies are changed
   */
  const onChange = (companies) => {
    setCompanies(companies);

    onUpdate({
      companies: companies.map(company => company._id),
      expandedCompanies: companies,
    });
  };

  /**
   * Close the third panel on the sidebar
   */
  const onCloseAvailable = () => {
    setPanel({
      thirdPanel: {
        show: false,
      },
    });

    // Reset the children after it's been hidden
    setTimeout(() => {
      setPanel({
        thirdPanel: {
          children: null,
        },
      });
    }, 900);
  };

  const onClickAssign = () => {
    setPanel({
      thirdPanel: {
        width: window.innerWidth,
        show: true,
        children: (
          <CompanySelection
            selected={companies}
            customToolbar={(
              <VibeIcon
                icon={viClose}
                color={color.white}
                hoverColor={color.white}
                size={24}
                onClick={onCloseAvailable}
              />
            )}
            assigning
            allowChanges
            onChange={onChange}
          />
        ),
      },
    });
  };

  const onClose = () => {
    setPanel({
      extraPanel: {
        show: false,
      },
    });

    // Reset the children after it's been hidden
    setTimeout(() => {
      setPanel({
        extraPanel: {
          children: null,
        },
      });
    }, 900);
  };

  return (
    <CompanySelection
      selected={companies}
      customToolbar={(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          {allowChanges && (
            <VibeButton
              text="Assign Companies"
              color="primary"
              testId="partner-companies-assign-button"
              onClick={onClickAssign}
            />
          )}

          <VibeIcon
            className="close"
            icon={viClose}
            color={color.manatee}
            hoverColor={color.obsidian}
            size={24}
            onClick={onClose}
          />
        </div>
      )}
      allowChanges={allowChanges}
      onChange={onChange}
    />
  );
}

PartnerCompanies.propTypes = {
  companies: PropTypes.arrayOf(PropTypes.object),
  /** Allow changes to the selection */
  allowChanges: PropTypes.bool,
  onUpdate: PropTypes.func,
};

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(null, mapDispatchToProps)(PartnerCompanies);
